import { createStore, useStore } from 'zustand';
import { IdentityState, getDefaultIdentityState } from './state';
import { getIdentityConfig } from '../config';
import { logoutRequest } from '../api/logout';
import { IdentityLogoutResult, IdentityLogoutResultType } from '../types';

export interface IdentityStore extends IdentityState {
  update(newState: Partial<IdentityState>): void;
  logout(): Promise<IdentityLogoutResult>;
}

export const identityStore = createStore<IdentityStore>((set) => ({
  ...getDefaultIdentityState(),
  update: (newState) => set(newState),
  logout: async () => {
    try {
      await logoutRequest();
      set({ user: undefined });
      getIdentityConfig().onLogout();

      return { resultType: IdentityLogoutResultType.Resolve };
    } catch (error) {
      return { resultType: IdentityLogoutResultType.Reject, error };
    }
  },
}));

export function useIdentityContext(): IdentityStore;
export function useIdentityContext<T>(selector: (state: IdentityStore) => T): T;
export function useIdentityContext<T>(selector?: (state: IdentityStore) => T) {
  return useStore(identityStore, selector as any);
}
